/* dev-faq.js — single-open accordion for the FAQ section */
(function () {
  'use strict';

  function closeItem(item) {
    item.classList.remove('is-open');
    var trigger = item.querySelector('[data-faq-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function openItem(item) {
    item.classList.add('is-open');
    var trigger = item.querySelector('[data-faq-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function initFaq(root) {
    if (!root || root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger || !root.contains(trigger)) return;

      var item = trigger.closest('[data-faq-item]');
      if (!item) return;

      var wasOpen = item.classList.contains('is-open');

      // single-open: collapse every item first
      items.forEach(closeItem);

      // re-open the clicked one unless it was the one already open (toggle off)
      if (!wasOpen) openItem(item);
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-faq]');
    Array.prototype.forEach.call(roots, initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest ? event.target.closest('[data-faq-item]') : null;
    if (!item) return;
    var root = item.closest('[data-faq]');
    if (root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-faq-item]'), closeItem);
    }
    openItem(item);
  });
})();
